import { render, staticRenderFns } from "./link-list.vue?vue&type=template&id=2d582b66&scoped=true"
import script from "./link-list.vue?vue&type=script&lang=js"
export * from "./link-list.vue?vue&type=script&lang=js"
import style0 from "./link-list.vue?vue&type=style&index=0&id=2d582b66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d582b66",
  null
  
)

export default component.exports